export const DRAWER_WIDTH = 72;
